import { DeepLinkConfig } from "ionic-angular";
import { Dashboard } from "../components/dashboard/dashboard";
import { Login } from "../components/login/login/login";
import { ForgotPassword } from "../components/login/forgot-password/forgot-password";
import { ResetPassword } from "../components/login/reset-password/reset-password";
import { PostListContainer } from "../partials/post/post-list-container/post-list-container";
import { SinglePost } from "../components/single-post/single-post";
import { Profile } from "../components/profile/profile";
import { EditProfile } from "../components/edit-profile/edit-profile";
import { AcceptInvitation } from "../components/login/accept-invitation/accept-invitation";
import { Search } from "../components/search/search";
import { AdminPanel } from "../components/admin-panel/admin-panel";
import { NotificationsPage } from "../components/notifications-page/notifications-page";
import { NotificationSettings } from "../components/notification-settings/notification-settings";
import { Register } from "../components/login/register/register";
import { ChatPage } from '../components/chat-page/chat-page';

declare const buildConfig: any;

export const ROUTES: DeepLinkConfig = { links: [

  { component: AdminPanel, name: 'admin-panel', segment: 'beheer/:template' },

  { component: Login, name: 'login', segment: 'inloggen' },
  { component: ForgotPassword, name: 'forgot-password', segment: 'inloggen/wachtwoord-vergeten', defaultHistory: ['login'] },
  { component: ResetPassword, name: 'reset-password', segment: 'inloggen/wachtwoord-instellen/:resetToken', defaultHistory: ['login'] },
  { component: AcceptInvitation, name: 'accept-invitation', segment: 'inloggen/accepteer-uitnodiging/:token', defaultHistory: ['login'] },
  { component: Register, name: 'register', segment: 'inloggen/registreren', defaultHistory: ['login'] },

  { component: Dashboard, name: 'dashboard', segment: 'dashboard'},

  { component: SinglePost, name: 'post', segment: 'vraag/:postId', defaultHistory: ['dashboard'] },

  { component: Search, name: 'search', segment: 'zoeken/:searchTerm', defaultHistory: ['dashboard'] },

  { component: NotificationsPage, name: 'notifications', segment: 'meldingen'},
  { component: ChatPage, name: 'chat-page', segment: 'chat' },
  { component: ChatPage, name: 'chat', segment: 'chat/:userId' },
  { component: Profile, name: 'my-profile', segment: 'mijn-profiel', defaultHistory: ['dashboard'] },
  { component: EditProfile, name: 'edit-profile', segment: 'mijn-profiel/bewerken', defaultHistory: ['my-profile', 'dashboard'] },
  { component: Profile, name: 'profile', segment: 'profiel/:userId', defaultHistory: ['dashboard'] },
  { component: EditProfile, name: 'edit-other-profile', segment: 'profiel/:userId/bewerken', defaultHistory: ['dashboard'] },

  { component: NotificationSettings, name: 'notification-settings', segment: 'notificatie-instellingen', defaultHistory: ['my-profile', 'dashboard'] },


  { component: PostListContainer, name: 'post-list-my-posts', segment: 'mijn-vragen' },
  { component: PostListContainer, name: 'post-list-unanswered', segment: 'onbeantwoord' },
  { component: PostListContainer, name: 'post-list-favourites', segment: 'favoriet' },
  { component: PostListContainer, name: 'post-list-answered', segment: 'beantwoord' },
  { component: PostListContainer, name: 'post-list-most-recent', segment: 'meest-recent' },
  { component: PostListContainer, name: 'post-list-tag', segment: 'tag/:tagId' },
  { component: PostListContainer, name: 'post-list-group-posts', segment: 'groep/:userGroupId' },
  { component: PostListContainer, name: 'post-list-category', segment: 'categorie/:categoryId' }
]};



// WEBPACK FOOTER //
// ./src/app/app.routes.ts